module.exports = __webpack_public_path__ + "assets/img/zhanwei3.0a0dd168.png";